import React from "react";

import "assets/scss/components/form/formInput.scss";



class FormInput extends React.Component {
	constructor(props) {
		super(props);
	}

    render() {
        const { className, isMarginBtmOptional } = this.props;

        return (
            <div className={"component-form component-formInput "+
                            ((className)?className+" ":"")+
                            ((isMarginBtmOptional)?"":"component-formInputOptions_btmSpacing ")}>
                {this.props.children}
            </div>
        );
    }
}



export { FormInput };
